export default __webpack_public_path__ + "static/Mosta_for_EasyTipster-5b00e4368c9dac04d5b48f18ca2d81eb.png";